import { useEffect, useState } from "react";
import "./ContactPage.css";

function ContactPage() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setCopied(false);
    }, 2200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [copied]);

  const email = "getit.lhamb@gmail.com";

  async function handleCopyEmail() {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <section className="contact-page">
      <h1 className="contact-page__title">Contact Me</h1>

      <p className="contact-page__intro">
        Feel free to reach out to me for any inquiries or collaborations. You
        can contact me via email at
      </p>

      <button
        className="contact-page__email"
        type="button"
        title="Copy email to clipboard"
        onClick={handleCopyEmail}
      >
        {email}
      </button>

      <p className={`contact-page__copied${copied ? " is-visible" : ""}`}>
        Email copied to clipboard
      </p>
    </section>
  );
}

export default ContactPage;
